import { Layout } from 'antd';
import {useEffect} from 'react';
import SideBar from './SideBar';
import {getStoredUser, refreshStoredUser} from '../utils';

const { Header: AntHeader, Content, Sider } = Layout;

const RootLayout = () => {
	useEffect(() => {
		const user = getStoredUser();

		if (user?.token) {
			refreshStoredUser(user);
		}
	}, []);

	return (
		<Layout>
			<SideBar />
		</Layout>
	)
}

export default RootLayout
